// types/setup.ts
export interface SetupProgress {
  parentInformation: boolean;
  employerManagement: boolean;
  employeeManagement: boolean;
  pensions: boolean;
  earnings: boolean;
  timeOff: boolean;
  filings: boolean;
  payruns: boolean;
}

export interface MenuPermissions {
  path: string;
  requiresSetup: boolean;
  requiredItems?: (keyof SetupProgress)[];
}

export const MENU_PERMISSIONS: Record<string, MenuPermissions> = {
  "/": { path: "/", requiresSetup: false },
  "/referrals": { path: "/referrals", requiresSetup: false },
  "/contract": { path: "/contract", requiresSetup: false },
  "/parent-info": {
    path: "/parent-info",
    requiresSetup: true,
    requiredItems: [], // Base requirement
  },
  "/employer": {
    path: "/employer",
    requiresSetup: true,
    requiredItems: ["parentInformation"],
  },
  "/employees": {
    path: "/employees",
    requiresSetup: true,
    requiredItems: ["parentInformation", "employerManagement"],
  },
  "/pensions": {
    path: "/pensions",
    requiresSetup: true,
    requiredItems: [
      "parentInformation",
      "employerManagement",
      "employeeManagement",
    ],
  },
  "/earnings": {
    path: "/earnings",
    requiresSetup: true,
    requiredItems: [
      "parentInformation",
      "employerManagement",
      "employeeManagement",
    ],
  },
  "/time-off": {
    path: "/time-off",
    requiresSetup: true,
    requiredItems: [
      "parentInformation",
      "employerManagement",
      "employeeManagement",
    ],
  },
  "/filings/employer": {
    path: "/filings/employer",
    requiresSetup: true,
    requiredItems: [
      "parentInformation",
      "employerManagement",
      "employeeManagement",
    ],
  },
  "/employee-submissions": {
    path: "/employee-submissions",
    requiresSetup: true,
    requiredItems: [
      "parentInformation",
      "employerManagement",
      "employeeManagement",
    ],
  },
};
